import { Controller } from "@hotwired/stimulus"

// Keeps a message thread pinned to its newest message: the container scrolls on its own, so
// opening a thread — or having one streamed into the frame — otherwise lands at the top.
//
// Driven by target callbacks rather than connect(): the same hook covers the messages present
// on render and the ones Turbo appends later, and a swapped-in thread is a new element, so it
// starts pinned again.
export default class extends Controller {
  static targets = ["message"]

  // Scrolling stops following once the reader scrolls up to read history, and resumes when
  // they come back to the bottom.
  static values = { pinned: { type: Boolean, default: true } }

  messageTargetConnected() {
    if (this.pinnedValue) this.scrollToBottom()
  }

  trackPosition() {
    this.pinnedValue = this.distanceFromBottom <= this.threshold
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }

  get distanceFromBottom() {
    return this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight
  }

  // A bubble's worth of slack, so a reader sitting just shy of the bottom still follows along.
  get threshold() {
    return 60
  }
}
